import { useRef, useState } from 'react';
import '../css/contact.css';

export default function Contact() {
  const nameRef = useRef<HTMLInputElement | null>(null);
  const emailRef = useRef<HTMLInputElement | null>(null);
  const phoneRef = useRef<HTMLInputElement | null>(null);
  const messageRef = useRef<HTMLTextAreaElement | null>(null);
  const [nameValue, setNameValue] = useState('');
  const [emailValue, setEmailValue] = useState('');
  const [phoneValue, setPhoneValue] = useState('');
  const [messageValue, setMessageValue] = useState('');

  const [responseMessage, setResponseMessage] = useState('');
  const [responseStatus, setResponseStatus] = useState('');

  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [messageError, setMessageError] = useState('');

  // Validation functions
  const validateName = (name: string) => {
    return name.trim().length > 0;
  };

  const validateEmail = (email: string) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone: string) => {
    const phoneRegex = /^[0-9]+$/; // Only numbers
    return phone.trim().length > 0 && phoneRegex.test(phone);
  };

  const validateMessage = (message: string) => {
    return message.trim().length > 0;
  };

  const sendFormData = async () => {
    let valid = true;

    if (!validateName(nameValue)) {
      setNameError('Imię jest wymagane');
      valid = false;
    } else {
      setNameError('');
    }

    if (!validateEmail(emailValue)) {
      setEmailError('Wprowadź poprawny adres e-mail');
      valid = false;
    } else {
      setEmailError('');
    }

    if (!validatePhone(phoneValue)) {
      setPhoneError('Numer telefonu jest wymagany i musi zawierać tylko cyfry');
      valid = false;
    } else {
      setPhoneError('');
    }

    if (!validateMessage(messageValue)) {
      setMessageError('Wiadomość nie może być pusta');
      valid = false;
    } else {
      setMessageError('');
    }

    if (!valid) {
      setResponseMessage('');
      setResponseStatus('');
      return;
    }

    const formData = new FormData();
    formData.append('name', nameValue);
    formData.append('email', emailValue);
    formData.append('phone', phoneValue);
    formData.append('message', messageValue);

    try {
      const response = await fetch('mail.php', {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      if (result.status === "success") {
        setResponseMessage(result.message);
        setResponseStatus("success");
        setNameError('');
        setEmailError('');
        setPhoneError('');
        setMessageError('');
      } else if (result.status === "fail" && result.errors) {
        setResponseMessage('');
        setResponseStatus('fail');
        setNameError(result.errors.name || '');
        setEmailError(result.errors.email || '');
        setPhoneError(result.errors.phone || '');
        setMessageError(result.errors.message || '');
        if (result.errors.global) {
          setResponseMessage(result.errors.global);
        }
      }
    } catch (error) {
      setResponseMessage('Błąd połączenia z serwerem.');
      setResponseStatus('fail');
    }
  };

  return (
    <div className="contact" id="contact">
      <h1 className="outline">KONTAKT</h1>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          sendFormData();
        }}
      >
        <div className={nameValue.length > 0 ? 'input active' : 'input'}>
          <input
            type="text"
            name="firstname"
            ref={nameRef}
            onChange={() => {
              setNameValue(nameRef.current!.value);
              setNameError('');
            }}
          />
          <span>Imię</span>
          {nameError && <div className="field-error">{nameError}</div>}
        </div>
        <div className={emailValue.length > 0 ? 'input active' : 'input'}>
          <input
            type="text"
            name="email"
            ref={emailRef}
            onChange={() => {
              setEmailValue(emailRef.current!.value);
              setEmailError('');
            }}
          />
          <span>Adres e-mail</span>
          {emailError && <div className="field-error">{emailError}</div>}
        </div>
        <div className={phoneValue.length > 0 ? 'input active' : 'input'}>
          <input
            type="text"
            name="phonenumber"
            ref={phoneRef}
            onChange={() => {
              setPhoneValue(phoneRef.current!.value);
              setPhoneError('');
            }}
          />
          <span>Numer telefonu</span>
          {phoneError && <div className="field-error">{phoneError}</div>}
        </div>
        <div className={messageValue.length > 0 ? 'input active' : 'input'}>
          <textarea
            ref={messageRef}
            rows={10}
            onChange={() => {
              setMessageValue(messageRef.current!.value);
              setMessageError('');
            }}
          />
          <span>Wiadomość</span>
          {messageError && <div className="field-error">{messageError}</div>}
        </div>

        {responseStatus && (
          <div
            className={`response-message ${responseStatus === 'success' ? 'success' : 'fail'}`}
          >
            <p>{responseMessage}</p>
          </div>
        )}
        <button className="button" type="submit">
          Wyślij wiadomość
        </button>
      </form>

    </div>
  );
}
